import { render, staticRenderFns } from "./VideoColumn.vue?vue&type=template&id=bf7abeb4&scoped=true&"
import script from "./VideoColumn.vue?vue&type=script&lang=js&"
export * from "./VideoColumn.vue?vue&type=script&lang=js&"
import style0 from "./VideoColumn.vue?vue&type=style&index=0&id=bf7abeb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7abeb4",
  null
  
)

export default component.exports